<template>
    <tr style="height: 110px;" v-if="width > 767">
        <th>
            <div class="d-flex justify-content-between position-relative">
                <span class="mt-1">{{ columnName }}</span><span class="text-white required">必須</span>
            </div>
        </th>
        <td>
            <input class="rounded border" size="110" v-model="name" />
            <p class="text-start text-danger pt-3" v-if="!checkName">{{ nameError }}</p>
        </td>
    </tr>
    <div v-else>
        <div class="d-flex justify-content-between position-relative p-3 rounded" style="background: #FAF4EC; ">
            <span class="mt-1 sp-input-column">{{ columnName }}</span>
            <span class="text-white required required-column">必須</span>
        </div>
        <input class="rounded border sp-input" v-model="name" />
        <p class="text-start text-danger" v-if="!checkName">{{ nameError }}</p>
    </div>
</template>

<script>
export default ({
    props: {
        columnName: String,
    },
    data() {
        return {
            nameError: '※ お名前は必須です',
            width: this.$store.state.width,
        }
    },
    computed: {
        name: {
            get() {
                return this.$store.state.name
            },
            set(v) {
                this.$store.commit('updateName', v)
            }
        },
        checkName() {
            let isNamePassCheck = true

            if (this.name.length === 0) {
                isNamePassCheck = false
            }

            this.$emit('isNamePassCheck', isNamePassCheck)

            return isNamePassCheck
        },
    },
    mounted: function () {
        window.addEventListener('resize', this.headlineResize)
    },
    methods: {
        headlineResize() {
            this.width = window.outerWidth;
        },
    },
})
</script>
